/* earbit: mirror newsletter signups to the external mailing list.

   Every signup form on the site is Shopify's native customer form, which
   posts full-page and comes back with `?customer_posted=true` on success.
   The submitted email is not in that response, so it is stashed in
   sessionStorage on submit and sent to the endpoint once Shopify confirms.
   Shopify remains the record of consent; this is a one-way copy. */

(() => {
  const config = window.earbitSubscribeSync;
  if (!config || !config.url) return;

  const PENDING_KEY = 'earbit-subscribe-pending';

  const isNewsletterForm = (form) => {
    const tags = form.querySelector('input[name="contact[tags]"]');
    return Boolean(tags && /\bnewsletter\b/.test(tags.value));
  };

  // Capture the address before the page navigates.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !isNewsletterForm(form)) return;
    const email = form.querySelector('input[name="contact[email]"]');
    if (!email || !email.value) return;
    try {
      sessionStorage.setItem(PENDING_KEY, email.value.trim());
    } catch (error) {
      /* Private browsing — nothing to mirror, Shopify still gets the signup. */
    }
  });

  const send = (email) => {
    const body = new FormData();
    body.append('email', email);
    if (config.tags) body.append('tags', config.tags);

    // The endpoint answers with a redirect and no CORS headers, so the
    // response is opaque either way; sendBeacon survives navigation.
    if (navigator.sendBeacon && navigator.sendBeacon(config.url, body)) return;
    fetch(config.url, { method: 'POST', mode: 'no-cors', body, keepalive: true }).catch(() => {});
  };

  // Shopify confirmed the signup on this load: mirror it exactly once.
  if (new URLSearchParams(window.location.search).get('customer_posted') !== 'true') return;

  let pending = null;
  try {
    pending = sessionStorage.getItem(PENDING_KEY);
    sessionStorage.removeItem(PENDING_KEY);
  } catch (error) {
    pending = null;
  }
  if (pending) send(pending);
})();
